import type { en } from './en';
export const cn: typeof en = {
  login: {
    title: 'DID 登录',
    description: '请输入您的 DID 以访问聊天',
  },
  logo: 'Nuwa AI',
  home: {
    loading: '加载中...',
  },
  language: {
    english: '英文',
    chinese: '中文',
  },
  nav: {
    sidebar: {
      new: '新建聊天',
      chat: '聊天',
      settings: '设置',
      search: '搜索',
      campaigns: '任务活动',
      capStore: 'Cap 商店',
      artifact: '文件',
      togglePin: '固定',
      toggleUnpin: '取消固定',
      wallet: '账户',
    },
    profile: {
      toggleTheme: '切换{{mode}}模式',
      signOut: '退出登录',
      clearStorage: '清理所有存储（测试用）',
    },
    menu: {
      preferences: '偏好设置',
      theme: '主题',
      language: '语言',
      system: '跟随系统',
      light: '浅色',
      dark: '深色',
    },
  },
  aiProvider: {
    modelSelector: {
      selectModel: '选择模型',
      auto: '自动',
      autoDescription: '自动选择最佳模型',
      webSearch: '网络搜索',
      contextSize: {
        low: '低',
        medium: '中',
        high: '高',
      },
      moreModels: '更多模型',
      allModels: '所有模型',
    },
    modelDialog: {
      title: {
        autoSettings: '自动设置和推荐',
        favoriteModels: '收藏模型',
        providerModels: '{{provider}} 模型',
        allModels: '所有模型',
        providers: '提供商',
      },
      search: {
        placeholder: '搜索模型...',
      },
      sort: {
        name: '名称',
        priceLowToHigh: '价格 (从低到高)',
        priceHighToLow: '价格 (从高到低)',
      },
      loading: {
        title: '正在加载模型...',
      },
      error: {
        failedToLoad: '加载模型失败',
        noModelsAvailable: '暂无可用模型',
      },
      favoriteEmpty: {
        title: '暂无收藏模型',
        description: '您可以点击模型卡片上的星标将其添加到收藏',
      },
    },
    autoSettings: {
      focusCategory: {
        title: '重点分类',
        placeholder: '选择分类（可选）',
        none: '无',
      },
      optimizeFor: {
        title: '优化目标',
        speed: '速度',
        cost: '成本',
        latency: '延迟',
      },
      advancedSettings: {
        title: '高级设置',
        description: '用于模型选择的高级优化设置。',
        minContextLength: '最小上下文长度',
        contextPlaceholder: '例如：8000',
      },
      recommendedModels: '推荐模型',
    },
    modelCard: {
      pricing: {
        inputTokens: '/百万输入词元',
        outputTokens: '/百万输出词元',
      },
    },
    sidebar: {
      title: '选择模型',
      tabs: {
        auto: '自动',
        favorite: '收藏',
        all: '全部',
        providers: '提供商',
      },
    },
    category: {
      models: '模型',
    },
  },
  capStore: {
    title: 'Cap 商店',
    description: '发现并安装能力，提升你的体验',
    searchPlaceholder: '搜索能力...',
    sidebar: {
      favorites: '收藏能力',
      recent: '最近使用',
      installed: '已安装能力',
      all: '所有能力',
    },
    home: {
      topRated: '高评分 AI 能力',
      trending: '热门 AI 能力',
      latest: '最新 AI 能力',
      viewMore: '查看更多',
      noCaps: '暂无可用 AI 能力',
    },
    status: {
      loading: '正在加载 AI 能力...',
      fetching: '正在从商店获取最新能力。',
      error: '加载 AI 能力出错',
      errorDesc: '获取能力失败，请重试。',
      tryAgain: '重试',
      noCaps: '未找到能力',
      noFavoriteCaps: '暂无收藏能力',
      noRecentCaps: '暂无最近使用',
      noInstalledCaps: '暂无已安装能力',
      noCapsDesc: {
        search: '请调整搜索词或浏览其他分类。',
        category: '此分类下暂无能力。',
      },
      noFavoriteCapsDesc: '您还没有收藏任何能力。浏览商店并收藏您喜欢的能力。',
      noRecentCapsDesc: '您最近还没有使用任何能力。试试运行一个能力吧。',
      noInstalledCapsDesc: '您还没有安装任何能力。浏览商店寻找要安装的能力。',
      noMoreCaps: '已经到底了',
    },
    card: {
      update: '有可用更新',
      disabled: '已禁用',
      installed: '已安装',
      install: '安装',
      by: '作者：{{author}}',
      version: 'v{{version}}',
      downloads: '下载量',
      rating: '评分',
      installDate: '安装于 {{date}}',
    },
  },
  chatHistory: {
    noChats: '暂无聊天',
    startConversation: '开始对话后会显示在这里',
    today: '今天',
    thisWeek: '本周',
    aWeekAgo: '一周前',
    older: '更早',
    loginToSave: '登录 DID 以保存聊天记录！',
    pinnedChats: '置顶聊天',
    recentChats: '最近聊天',
    moreChats: '更多聊天',
  },
  dialog: {
    renameChat: {
      title: '重命名聊天',
      placeholder: '输入聊天名称',
    },
  },
  search: {
    searchPlaceholder: '搜索聊天...',
    noChatsHistory: '没有找到聊天记录。',
  },
  chat: {
    restoreVersion: '恢复此版本',
    backToLatest: '返回最新版本',
    viewingPrevious: '正在查看历史版本',
    restoreToEdit: '恢复此版本以进行编辑',
    loadingChat: '正在加载聊天...',
  },
  error: {
    info: '信息',
    warning: '警告',
    error: '错误',
    critical: '严重错误',
    network: '网络连接失败，请检查您的网络。',
    api: '服务暂时不可用，请稍后再试。',
    storage: '无法本地保存数据，请检查浏览器存储设置。',
    validation: '输入无效，请检查后重试。',
    permission: '没有权限，请检查您的访问权限。',
    notFound: '未找到请求的{{resource}}。',
    timeout: '{{operation}}超时，请重试。',
    generic: '发生未知错误，请重试。',
    tryAgain: '发生错误，请重试。',
    persist: '如问题持续，请检查网络或刷新页面。',
  },
  errors: {
    database: '执行数据库查询时发生错误。',
    badRequestApi: '无法处理请求。请检查您的输入并重试。',
    unauthorizedAuth: '您需要先登录才能继续。',
    forbiddenAuth: '您的账户无权访问此功能。',
    rateLimitChat: '您今天已超过最大消息数量。请稍后再试。',
    notFoundChat: '未找到请求的聊天。请检查聊天 ID 并重试。',
    forbiddenChat: '此聊天属于其他用户。请检查聊天 ID 并重试。',
    unauthorizedChat: '您需要登录才能查看此聊天。请登录并重试。',
    offlineChat: '发送消息时遇到问题。请检查网络连接并重试。',
    notFoundDocument: '未找到请求的文档。请检查文档 ID 并重试。',
    forbiddenDocument: '此文档属于其他用户。请检查文档 ID 并重试。',
    unauthorizedDocument: '您需要登录才能查看此文档。请登录并重试。',
    badRequestDocument: '创建或更新文档的请求无效。请检查您的输入并重试。',
    default: '出了点问题。请稍后再试。',
  },
  actions: {
    viewChanges: '查看更改',
    viewPrev: '查看上一个版本',
    viewNext: '查看下一个版本',
    copy: '复制到剪贴板',
    copied: '已复制到剪贴板！',
    addPolish: '润色',
    requestSuggestions: '请求建议',
    delete: '删除',
    more: '更多',
    rename: '重命名',
    pin: '置顶',
    unpin: '取消置顶',
    cancel: '取消',
    confirm: '确认',
  },
  document: {
    creating: '正在创建',
    created: '已创建',
    updating: '正在更新',
    updated: '已更新',
    addingSuggestions: '正在添加建议',
    addedSuggestions: '已添加建议',
    viewingNotSupported: '暂不支持在共享聊天中查看文件。',
  },
  suggestedActions: [
    {
      title: 'Next.js 有什么优势',
      label: '为什么选择 Next.js？',
      action: 'Next.js 有什么优势？',
    },
    {
      title: '写代码演示',
      label: 'Dijkstra 算法',
      action: '写代码演示 Dijkstra 算法',
    },
    {
      title: '帮我写一篇关于',
      label: '硅谷的文章',
      action: '帮我写一篇关于硅谷的文章',
    },
    {
      title: '旧金山天气',
      label: '现在如何？',
      action: '旧金山现在的天气如何？',
    },
  ],
  submit: {
    loading: '加载中',
    submit: '提交表单',
  },
  greeting: {
    hello: '你好！',
    help: '今天我能为您做些什么？',
  },
  version: {
    viewingPrevious: '正在查看历史版本',
    restoreToEdit: '恢复此版本以进行编辑',
    restore: '恢复此版本',
    backToLatest: '返回最新版本',
    failedRestore: '恢复版本失败',
  },
  artifact: {
    viewChanges: '查看更改',
    viewPrev: '查看上一个版本',
    viewNext: '查看下一个版本',
    copy: '复制到剪贴板',
    copied: '已复制到剪贴板！',

    text: {
      description: '用于文本内容，如起草文章和邮件。',
      actions: {
        versionChange: '查看差异',
        undo: '撤销更改',
        redo: '重做更改',
        copy: '复制文本',
      },
      addPolish: '最终润色',
      requestSuggestions: '请求建议',
      polishPrompt:
        '请进行最终润色，检查语法，添加章节标题以改善结构，确保内容流畅易读。',
      suggestionsPrompt: '请提供可以改进写作的建议。',
    },

    code: {
      description: '用于代码生成；代码执行仅支持 Python 代码。',
      actions: {
        run: '运行代码',
        undo: '撤销更改',
        redo: '重做更改',
        copy: '复制代码',
      },

      run: '运行',
      executeCode: '执行代码',
      copyCode: '复制代码到剪贴板',
      addComments: '添加注释',
      addLogs: '添加日志',
      addCommentsPrompt: '为代码片段添加注释以便理解',
      addLogsPrompt: '为代码片段添加日志以便调试',
    },

    sheet: {
      description: '用于处理电子表格',
      copyAsCsv: '复制为 .csv',
      copiedCsv: '已复制 csv 到剪贴板！',
      formatData: '格式化和清理数据',
      analyzeData: '分析和可视化数据',
      formatPrompt: '您能帮忙格式化和清理数据吗？',
      analyzePrompt: '您能通过创建新的 Python 代码工件来分析和可视化数据吗？',
      actions: {
        undo: '撤销更改',
        redo: '重做更改',
        copy: '复制表格为 CSV',
      },
    },

    image: {
      description: '用于图像生成',
      actions: {
        undo: '撤销更改',
        redo: '重做更改',
        copy: '复制图像',
      },
      copyImage: '复制图像到剪贴板',
      copiedImage: '已复制图像到剪贴板！',
    },
  },
  documentTool: {
    creating: '正在创建',
    created: '已创建',
    updating: '正在更新',
    updated: '已更新',
    addingSuggestions: '正在添加建议',
    addedSuggestions: '已添加建议',
    viewingNotSupported: '暂不支持在共享聊天中查看文件。',
  },
  upload: {
    failedCreateUrl: '创建文件 URL 失败',
    failedUpload: '文件上传失败，请重试！',
    errorUploading: '上传文件时出错！',
  },
  settings: {
    title: '设置',
    description: '管理您的账户设置和偏好。',
    sections: {
      profile: {
        title: '个人资料',
        description: '管理您的资料信息',
        subtitle: '这是您的 Nuwa 助手的信息。',
      },
      placeholders: {
        title: '占位符',
        description: '占位符用于调试设置 UI。',
        subtitle: '这是占位符用于调试设置 UI。',
      },
      system: {
        title: '系统',
        description: '系统设置和维护',
        subtitle: '管理系统级设置和数据。',
      },
      general: {
        title: '通用',
        subtitle: '通用应用设置。',
      },
    },
    profile: {
      didInformation: {
        title: 'DID 信息',
        description: '您的去中心化标识符和认证状态',
        did: 'DID',
        notSet: '未设置',
        authenticated: '已认证',
        notAuthenticated: '未认证',
        copy: '复制',
        copied: 'DID 已复制到剪贴板！',
      },
      photo: {
        title: '头像',
        description: '这将显示在您的个人资料中。',
        changePhoto: '更换头像',
        remove: '移除',
        fileTypes: 'JPG、PNG 或 GIF 格式。最大 5MB。',
      },
      displayName: {
        title: '显示名称',
        description: '这是您的公开显示名称。',
        name: '姓名',
        placeholder: '输入您的姓名',
        save: '保存',
      },
      logout: {
        title: '退出登录',
        description: '退出您的账户',
        button: '退出登录',
        confirmTitle: '您确定要这样做吗？',
        confirmDescription:
          '您将退出您的账户。您需要重新登录才能继续使用应用程序。',
        confirmButton: '退出登录',
        cancel: '取消',
        success: '退出登录成功',
      },
    },
    system: {
      clearAllStorage: {
        title: '清空所有存储',
        description: '永久删除所有存储的数据，包括聊天、设置和文件',
        warning: '警告：此操作无法撤销',
        warningDescription:
          '这将永久删除您的所有数据，包括聊天记录、设置、上传的文件和文档。您需要重新登录。',
        button: '清空所有数据',
        confirmTitle: '您确定要这样做吗？',
        confirmDescription: '此操作无法撤销。这将永久删除您的所有数据：',
        confirmButton: '是的，清空一切',
        cancel: '取消',
        clearing: '正在清空...',
        success: '所有存储已成功清空',
        error: '清空存储失败。请重试。',
        dataTypes: {
          chats: '所有聊天对话和历史记录',
          settings: '用户偏好和设置',
          files: '上传的文件和附件',
          documents: '创建的文档和工件',
        },
      },
      devMode: {
        title: '开发者模式',
        description: '启用或禁用开发者模式。',
      },
      language: {
        title: '语言',
        description: '选择你偏好的语言。',
      },
    },
  },
};
